import * as React from 'react';

require('./toolbar.scss');

export interface ToolbarProps {
  className?: string;
}

export const Toolbar: React.FC<ToolbarProps> = ({ className, children }) => {
  const classNames = ["l-toolbar"];

  if (className)
    classNames.push(className);


  return (
    <div className={classNames.join(' ')}>
      {children}
    </div>
  );
};
